import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

const EmptyListItemParts = ['container', 'text'] as const

const helpers = createMultiStyleConfigHelpers(EmptyListItemParts)
export const EmptyListItemStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '1.25rem',
      gap: '1rem',
    },
    text: {
      ...textStyles[textStyleKeys.Body2],
      textAlign: 'center',
      color: 'fg.muted',
    },
  },
})

export const useEmptyListItemStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(EmptyListItemStyle, props) as MultiStyleType<
    typeof EmptyListItemParts
  >
}
